import './spice/style';
import FormStructure from './spice/form_structure';

export default FormStructure;